<template>
  <BRow>
    <BCol cols="2">
      <p class="font-weight-bolder text-center">عنوان کلاس</p>
    </BCol>
    <BCol cols="2">
      <p class="font-weight-bolder text-center">تاریخ کلاس</p>
    </BCol>
    <BCol cols="2">
      <p class="font-weight-bolder text-center">ساعت کلاس</p>
    </BCol>
    <BCol cols="2">
      <p class="font-weight-bolder text-center">مهلت ثبت نام</p>
    </BCol>
    <BCol cols="1">
      <p class="font-weight-bolder text-center">تعداد شرکت کننده ها</p>
    </BCol>
    <BCol cols="1">
      <p class="font-weight-bolder text-center">لینک کلاس</p>
    </BCol>
    <BCol cols="2" class="mt-0">
      <p class="font-weight-bolder text-center">عملیات</p>
    </BCol>
    <BCol cols="12" class="mt-0">
      <hr class="mt-0" />
    </BCol>
    <template v-for="(classDetails, index) in classDetailsList">
      <MasterCreatedGroupClassDetailsContent
        :classMaxCapacity="classMaxCapacity"
        v-for="masterDetails in classDetails.masterDetails"
        :classDetails="masterDetails"
        :key="index"
        @refetch="refetch"
      ></MasterCreatedGroupClassDetailsContent>
    </template>
  </BRow>
</template>

<script>
export default {
  emits: ["refetch"],
  props: {
    classDetailsList: {
      type: Array,
    },
    classMaxCapacity: {
      type: [String, Number],
    },
  },
  methods: {
    refetch() {
      this.$emit("refetch");
    },
  },
  components: {
    MasterCreatedGroupClassDetailsContent,
    BRow,
    BCol,
  },
};
import MasterCreatedGroupClassDetailsContent from "@/views/components/GroupClass/MasterGroupClass/MasterCreatedGroupClassDetailsContent.vue";
import { BRow, BCol } from "bootstrap-vue";
</script>
